// extracted by mini-css-extract-plugin
module.exports = {"varselboks":"VarselboksPart_varselboks__F9fNw"};